"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectPage = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const S = __importStar(require("./RedirectPage.style"));
const Title_1 = __importDefault(require("./Title"));
const MAP_PAGE_PATH = "/";
const RedirectPage = ({ children }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        const timer = setTimeout(() => {
            navigate(MAP_PAGE_PATH);
        }, 10000);
        return () => clearTimeout(timer);
    }, [navigate]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(S.PageContainer, null,
            react_1.default.createElement(S.ContentContainer, null,
                react_1.default.createElement(Title_1.default, null),
                react_1.default.createElement(S.Description, null,
                    t("redirectPage.message"),
                    " "),
                react_1.default.createElement(S.BlueButton, { onClick: () => navigate(MAP_PAGE_PATH) }, t("redirectPage.button"))))));
};
exports.RedirectPage = RedirectPage;
